__turbopack_context__.v({
  "fullHeightCell": "zkI-oG_fullHeightCell",
  "wrappedBox": "zkI-oG_wrappedBox",
});
